import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';

/** Product name, truncated to 2 lines. */
export function CardName(): JSX.Element {
  const { productName } = useCardContext();

  return <Name>{productName}</Name>;
}

const Name = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #121516;
  display: -webkit-box;
  font-size: 14px;
  font-weight: 600;
  line-height: ${16 / 14};
  overflow: hidden;
`;
